export default function SelectEditTypeDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  alerts,
  editGeneratedReportsDialog,
  selectAdvisoryReportTypesDialog,
  selectReportTypesDialog,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSubmitEditType = _handleSubmitEditType;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false; 
  }

  function _handleSubmitEditType($event) {
    _handleCloseDialog();

    if (vm.selectedEditTypeId === 1) {
      ssDialogService.dialogs.reports.selectReportTypesDialog = ssDialogService.alert(
        selectReportTypesDialog.getOptions($event, {
          hasAdvisoryServices: vm.hasAdvisoryServices,
          reportPackage: vm.reportPackage,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.selectReportTypesDialog);
    }
    else if (vm.selectedEditTypeId === 2) {
      ssDialogService.dialogs.reports.editGeneratedReportsDialog = ssDialogService.alert(
        editGeneratedReportsDialog.getOptions($event, {
          hasAdvisoryServices: vm.hasAdvisoryServices,
          reportPackage: vm.reportPackage,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.editGeneratedReportsDialog);
    }
    else if (vm.selectedEditTypeId === 3) {
      ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog = ssDialogService.alert(
        selectAdvisoryReportTypesDialog.getOptions($event, {
          hasAdvisoryServices: vm.hasAdvisoryServices,
          reportPackage: vm.reportPackage,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog);
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectEditTypeDialog);
  }
}

SelectEditTypeDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'alerts',
  'editGeneratedReportsDialog',
  'selectAdvisoryReportTypesDialog',
  'selectReportTypesDialog',
];
